var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlayVideoModal = function SvgPlayVideoModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 12.333h41.667V54H22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.761 11.075C83.665 18.5 83.665 34 83.665 34s0 15.5-1.904 22.925c-1.058 4.104-4.154 7.333-8.075 8.425C66.566 67.333 42 67.333 42 67.333s-24.555 0-31.688-1.983c-3.937-1.108-7.029-4.333-8.075-8.425C.332 49.5.332 34 .332 34s0-15.5 1.904-22.925C3.295 6.971 6.39 3.742 10.311 2.65 17.445.667 42 .667 42 .667s24.566 0 31.687 1.983c3.938 1.108 7.03 4.333 8.075 8.425ZM33.665 48.583l25-14.583-25-14.583v29.166Z",
    fill: "#E2231B"
  })));
};

export default SvgPlayVideoModal;